// this script is render multi section. if you have to edit be careful.
// side of dropdown image gallery swiper
var ddBottomSwiper = new Swiper(".dd-swiperBottom", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 6,
  freeMode: true,
  watchSlidesProgress: true,
  on: {
    init: function () {
      previousActiveIndex = this.activeIndex;
    },
    click: function () {
      // console.log("this.activeIndex",this.activeIndex)
      // console.log("this.clickedIndex",this.clickedIndex)
      // console.log("previousActiveIndex",previousActiveIndex)

      if (this.clickedIndex < previousActiveIndex) {
        // console.log("Left");
        this.slideTo(this.clickedIndex - 1, 300, true);
        // console.log(this.clickedIndex - 1);
      } else {
        this.slideTo(this.clickedIndex, 300, true);
      }
      previousActiveIndex = this.clickedIndex;
      // console.log("-----------",)
    },
  },
});

var ddTopSwiper = new Swiper(".dd-swiperTop", {
  loop: true,
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: ddBottomSwiper,
  },
});

const shareImgProduct = document.querySelectorAll(".share_img_product");
if (!navigator.share) {
  shareImgProduct.forEach((each) => (each.style.display = "none"));
} else {
  shareImgProduct.forEach((each) => {
    each.addEventListener("click", (e) => {
      e.preventDefault();
      const shareData = {
        title: "Pedal Commander",
        text: "Hey, I just stumbled upon Pedal Commander. It is a performance part that will remove the acceleration lag from the throttle. Check it out!",
        url: `${window.location.href}`,
      };
      navigator
        .share(shareData)
        .then(() => {
          // console.log("page was shared");
        })
        .catch((error) => {
          console.log(error);
        });
    });
  });
}

function customSmoothScroll(x) {
  window.scrollTo({
    top: x,
    behavior: "smooth",
  });
}

const xdBannerDropdownOpenId = document.querySelector(
  "#xdBannerDropdownOpenId"
);
function ddActions() {
  if (window.innerWidth < 768) customSmoothScroll(755);      // not campaign scroll
  // if (window.innerWidth < 768) customSmoothScroll(1400);  // campaign scroll
}

xdBannerDropdownOpenId.addEventListener("click", ddActions);

// -------------------------------

const bottomDivider = document.querySelector(".pp-top-banner.pp-container") || document.querySelector(".pp-grid-parent");
const buyNowButtonForMobile = document.querySelector(".buyNow-buy-now-mobile");
const fixedBannerButton = document.querySelector(".fixed-banner-btn");

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting && window.innerWidth < 768) {
        // Banner görünmüyor ve ekran genişliği 768px'in altında ise

        // if( window.location.pathname.split('/').pop() != "suzuki-jimny"){
        // }
          buyNowButtonForMobile.style.display = "block";

        
        fixedBannerButton.style.display = "flex";
        // console.log("mobile buy now göster")
      } else {
        // Banner görünüyor veya ekran genişliği 768px'in üstünde ise
        buyNowButtonForMobile.style.display = "none";
        // console.log("mobile buy now gizle")
      }
    });
  },
  { threshold: 0 }
);

// Observer'ı banner elementine bağla
observer.observe(bottomDivider);

// Pencere boyutu değiştiğinde kontrol et
window.addEventListener("resize", () => {
  if (!observer) return;
  if (window.innerWidth < 768) {
    observer.observe(bottomDivider);
  } else {
    observer.unobserve(bottomDivider);
    buyNowButtonForMobile.style.display = "none";
  }
});
// ---------------------------

// tavk.to app
if (window.innerWidth < 1000) styleTawkFunc();

function styleTawkFunc() {
  const tawkWidgetInterval = setInterval(getTawkWidgetInterval, 1000);
  const clearTawkInterval = setInterval(clearTawkWidgetInterval, 10000);

  function getTawkWidgetInterval() {
    // console.log("tawk func run")
    let tawkWidgetVisibleIframe = document.querySelector(".richpanel-micro");

    if (tawkWidgetVisibleIframe) {
      // console.log("tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide')",tawkWidgetVisibleIframe.classList.contains('rp-micro-app-hide'))
      if (!tawkWidgetVisibleIframe.classList.contains("rp-micro-app-hide")) {
        fixedBannerButton.style.justifyContent = "left";
        // document.querySelector(".fixed-banner-btn button").style.width = "70%";
        document.querySelector(".fixed-banner-btn").style.right = "80px";
        document.querySelector(".fixed-banner-btn button").style.fontSize =
          "22px";
        // console.log("tawk render edildi ve interval del");
        clearInterval(tawkWidgetInterval);
      }
    }
  }

  function clearTawkWidgetInterval() {
    clearInterval(tawkWidgetInterval);
    clearInterval(clearTawkInterval);
    // console.log("tawk render edilmedi 10 sn sonra interval del")
  }
}

// anti_theft_black INFO
// c-pp-anti-theft-title-available.liquid snippet
const allAntiTheftTitleParent = document.querySelectorAll(
  ".antiTheftTitleParent"
);

allAntiTheftTitleParent.forEach((parent) => {
  const iconInfo = parent.querySelector(".antiTheftIconInfo");

  parent.addEventListener("mouseenter", () => {
    iconInfo.style.display = "block";
  });

  parent.addEventListener("mouseleave", () => {
    iconInfo.style.display = "none";
  });
});

// affirm duplicate render bug was fixed
document.addEventListener("DOMContentLoaded", function () {
  function moveAppToDesktop() {
    const mobileAffirm = document.querySelector(".onlyMobile .affirm_parent");
    const desktopAffirmContainer = document.querySelector(
      ".desktop-affirm_parent"
    );

    if (window.innerWidth >= 768 && mobileAffirm && desktopAffirmContainer) {
      desktopAffirmContainer.appendChild(mobileAffirm);
    }
  }

  moveAppToDesktop();

  window.addEventListener("resize", moveAppToDesktop);
});
